export default __webpack_public_path__ + "static/media/calculator.34d32358.png";